<template>
    <div class="col-sm-12">
        <div style="display: flex; flex-direction: column">
            <div style="display: flex; justify-content: space-between">
                <h2>Prospects</h2>
                <div>
                    <a class="btn btn-danger is-aligned-right" :href="url(`/admin/prospects/usdots`)">
                        <span class="glyphicon glyphicon-plus" aria-hidden="true"></span> Assign USDOTs
                    </a>
                </div>
            </div>

            <div>
                <div class="filter-group list-filter" style="display: flex; flex-wrap: wrap;">
                    <div class="form-group">
                        <label>Company Name</label>
                        <input type="text" class="form-control" v-model="filter.search" v-on:keyup.enter="refresh">
                    </div>
                    <div class="form-group">
                        <label>Min Trucks</label>
                        <input type="number" class="form-control" v-model="filter.min_trucks">
                    </div>
                    <div class="form-group">
                        <label>Max Trucks</label>
                        <input type="number" class="form-control" v-model="filter.max_trucks">
                    </div>
                    <div class="form-group">
                        <label>Min Job Posts</label>
                        <input type="number" class="form-control" v-model="filter.min_job_posts">
                    </div>
                    <div class="form-group">
                        <label>Min Reviews</label>
                        <input type="number" class="form-control" v-model="filter.min_reviews">
                    </div>
                    <div class="form-group">
                        <label>Last Contact</label>
                        <el-date-picker
                            v-model="filter.last_contact_from"
                            type="date"
                            format="M/d/yyyy"
                            value-format="yyyy-MM-dd"
                            placeholder="From"
                            style="width: 100%"
                        >
                        </el-date-picker>
                    </div>
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <el-date-picker
                            v-model="filter.last_contact_to"
                            type="date"
                            format="M/d/yyyy"
                            value-format="yyyy-MM-dd"
                            placeholder="To"
                            style="width: 100%"
                        >
                        </el-date-picker>
                    </div>
                    <div class="form-group">
                        <label>TR Employer</label>
                        <el-select
                            v-model="filter.tr_employer"
                            multiple
                            collapse-tags
                            placeholder="Select"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in lists.tr_employer_states"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="form-group" style="padding-top: 25px">
                        <btn cssClass="btn btn-secondary" icon="fas fa-redo-alt" :click="refresh">Filter</btn>
                    </div>
                </div>
            </div>

            <table class="table table-striped table-hover table-sticky-header custom-table" v-loading="loading">
                <thead>
                    <tr>
                        <th>
                            Company Name(s)
                        </th>
                        <th>USDOT</th>
                        <th>
                            Trucks<br>
                            <small>(RigDig)</small>
                        </th>
                        <th>Job Posts</th>
                        <th>Reviews</th>
                        <th>
                            Last Call/Email<br>
                            <small>(SalesForce)</small>
                        </th>
                        <th>
                            TR Employer<br>
                            <small>(SalesForce)</small>
                        </th>
                        <th>
                            State<br>
                            <small>(SalesForce)</small>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <prospect-list-row :row="row" v-for="row in rows" :key="row.id" />
                </tbody>
            </table>
            
            <div class="row" v-if="pagination.total > 0">
                <div class="col-sm-12 text-center">
                    <el-pagination 
                        layout="prev, pager, next"
                        background
                        v-bind:current-page.sync="pagination.page"
                        @current-change="changePage"
                        :page-size="pagination.perPage"
                        :total="pagination.total"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProspectListRow from "./prospect-list-row";

export default {
    components: {
        ProspectListRow
    },
    data() {
        return {
            filter: {
                search: '',
                min_trucks: null,
                max_trucks: null,
                min_job_posts: null,
                min_reviews: null,
                last_contact_from: null,
                last_contact_to: null,
                tr_employer: [],
                page: 1
            },
            rows: [],
            pagination: {
                page: 1,
                perPage: 100,
                total: 0
            },
            lists: {
                tr_employer_states: [
                    {
                        label: "Yes",
                        value: "Yes",
                    },
                    {
                        label: "No",
                        value: "No",
                    }
                ]
            },
            loading: true
        };
    },
    methods: {
        refresh() {
            this.loading = true;

            return axios.post(url(`admin/prospects/list/data`), this.filter)
                .then((response) => {
                    this.rows = response.data.rows;
                    this.pagination = response.data.pagination;
                    this.loading = false;
                });
        },
        changePage(page) {
            this.filter.page = page;
            this.refresh();
        },
        
    },
    mounted() {
        this.refresh();
    }
}
</script>